// ListLoadingOverlay — envoltório de tabela/lista que aplica LoadingOverlay translúcido
// no topo, mantendo o conteúdo visível durante reload (sort, paginação, busca).
//
// Uso:
//   <ListLoadingOverlay loading={loading}>
//     <Table>...</Table>
//   </ListLoadingOverlay>
//
// Comportamento:
//   - Posição relative no container.
//   - LoadingOverlay com blur 1, backgroundOpacity 0.5, zIndex 5.
//   - Loader sm centralizado.
import { Box, LoadingOverlay } from "@mantine/core";
import type { ReactNode, CSSProperties } from "react";

export interface ListLoadingOverlayProps {
  loading: boolean;
  children: ReactNode;
  /** Estilo extra do container externo. */
  style?: CSSProperties;
}

export function ListLoadingOverlay({ loading, children, style }: ListLoadingOverlayProps) {
  return (
    <Box pos="relative" style={style}>
      <LoadingOverlay
        visible={loading}
        zIndex={5}
        overlayProps={{ blur: 1, backgroundOpacity: 0.5 }}
        loaderProps={{ size: "sm" }}
      />
      {children}
    </Box>
  );
}

export default ListLoadingOverlay;
